<template>
  <div>
    <el-row>
      <el-col :span="18">
        <bai-du-map-vue :markerList='markerList' :center='center' :mapZoom='mapZoom' @mapClickMarker='mapClickMarker'></bai-du-map-vue>
      </el-col>
      <el-col :span="6">
        <div class="relative-time">
            <the-now-time></the-now-time>
        </div>
        <div class="relative-school-info">
            <school-search-info @schoolList='schoolList' @cityChange='cityChange' @eduOrSchoolChange='eduOrSchoolChange'></school-search-info>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import baiDuMapVue from './components/baiDuMapVue'
import schoolSearchInfo from './components/schoolSearchInfo' //右侧学校或教育局信息
import theNowTime from './components/theNowTime'
export default {
  name: "",
  components: {
      baiDuMapVue,
      schoolSearchInfo,
      theNowTime
  },
  props: {},
  data() {
    return {
        markerList:[],
        center:'',
        mapZoom:8
    };
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
      schoolList(list){
        list.reverse()
        this.markerList = list.map((item)=>{
            let lngAndLat = item.schoolCoordinate || item.eduCoordinate
            let arr = lngAndLat.split(',');
            item.markerPo= {
                lng:arr[0],
                lat:arr[1]
            }
            item.showInfoWindow = false
            return item
        })
      },
      cityChange(val){
        this.center = val.regionName || '河南'
        if (val.eduBuresuType == 0) {
            this.mapZoom = 8
        }else if(val.eduBuresuType == 1)
        {
            this.mapZoom = 10
        }else
        {
            this.mapZoom = 13
        }
      },
      eduOrSchoolChange(obj){
          this.markerList = []
          this.markerList.push(obj)
      },
    //   点击地图坐标
      mapClickMarker(item){
        if (item.type == 'school') {
            // 当前点击的是学校
            this.$store.commit('updateSchoolIdResizeInfo',item);
            this.$store.commit('updateSchoolIdResize',this.schoolIdResize + 1)
        }else{
            // 当前点击的是教育局
            this.$store.commit('updateEduIdResizeInfo',item);
            this.$store.commit('updateEduIdResize',this.eduIdResize + 1)
        }
      }
  },
    computed: {
        eduIdResize () {
            return this.$store.state.eduIdResize
        },
        schoolIdResize () {
            return this.$store.state.schoolIdResize
        }
    },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.top {
  margin-top: -10px;
  width: 100%;
  padding: 0 8.96% 0 5.52%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .right {
    display: flex;
    justify-content: flex-end;
  }
}
.relative-school-info{
    width: 411px;
    height: 28px;
}
</style>
